import clsx from 'clsx';

export default function StandingsTableSkeleton() {
  return (
    <div className='mb-4 animate-pulse inline-flex w-full flex-col border rounded-lg'>
      {[...Array(4)].map((_, i) => (
        <div
          key={`skeleton-row-${i}`}
          className={clsx(
            'flex w-full border-y border-gray-300 bg-gray-50',
            i === 0 && 'rounded-t-lg',
            i === 3 && 'rounded-b-lg'
          )}
        >
          <div className='inline-flex w-[10%] min-w-[40px] shrink-0 justify-center border-r px-2 py-4'>
            <div className='h-4 w-4 rounded bg-gray-300' />
          </div>

          <div className='md:w-[20%] w-[90%] min-w-[80px] shrink-0 border-r px-2 py-4 flex'>
            <div className='mb-1 h-4 w-2/5 rounded bg-gray-300' />
            <div className='ml-1 h-4 w-3/5 rounded bg-gray-300' />
          </div>

          {[...Array(9)].map((_, index) => (
            <div
              key={`skeleton-col-${index}`}
              className='hidden w-[5%] min-w-[30px] shrink-0 justify-center border-r px-2 py-4 md:inline-flex'
            >
              <div className='h-4 w-4 rounded bg-gray-300' />
            </div>
          ))}

          <div className='hidden w-[20%] min-w-[80px] shrink-0 justify-center border-r px-2 py-4 md:inline-flex'>
            <div className='h-5 w-5 rounded bg-gray-300' />
          </div>

          <div className='hidden w-[5%] min-w-[30px] shrink-0 justify-center border-r px-2 py-4 md:inline-flex'>
            <div className='h-4 w-4 rounded bg-gray-300' />
          </div>
        </div>
      ))}
    </div>
  );
}
